
import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { isSuperAdmin } from '@/services/admin.service';

/**
 * Hook to check if the current user is a super admin
 * @returns {Object} Object containing isSuperAdmin boolean and isLoading state
 */
export const useAdminStatus = () => {
  const { user } = useAuth();
  const [isUserSuperAdmin, setIsUserSuperAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      setIsLoading(true);
      
      if (!user?.id) {
        setIsUserSuperAdmin(false);
        setIsLoading(false);
        return;
      }

      try {
        const isAdmin = await isSuperAdmin(user.id);
        setIsUserSuperAdmin(isAdmin);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsUserSuperAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkAdminStatus();
  }, [user]);

  return { isSuperAdmin: isUserSuperAdmin, isLoading };
};
